import { Component, Input, OnInit } from '@angular/core';
import { Cargo } from 'src/app/core/interfaces/cargo';

@Component({
  selector: 'app-assigned-cargo-list',
  templateUrl: './assigned-cargo-list.component.html',
  styleUrls: ['./assigned-cargo-list.component.scss']
})
export class AssignedCargoListComponent implements OnInit {

  @Input() cargos: [];

  constructor() { }

  ngOnInit() {
  }

}
